import { Injectable } from '@angular/core';
import {Firestore, collection, doc, setDoc, deleteDoc, collectionData} from "@angular/fire/firestore";
import {CollectionReference, DocumentData} from "firebase/firestore";
import {User} from "../model/user";
import {Observable} from "rxjs";
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  usersRef: CollectionReference<DocumentData>;

  constructor(
    private afs: Firestore,
    private authService: AuthService,
  ) {
    this.usersRef = collection(this.afs, "users");
  }

  getAllOwners(): Observable<User[]>  {
    return collectionData(this.usersRef) as Observable<User[]>;
  }

  getServerParams(): Observable<any[]> {
    return collectionData(collection(this.afs, 'serverParams')) as Observable<any[]>;
  }

  setServerParam(key: string, value: any): Promise<void> {
    return setDoc(doc(this.afs, `serverParams/${key}`), value);
  }

  deleteServerParam(key: string): Promise<void> {
    return deleteDoc(doc(this.afs, `serverParams/${key}`));
  }
}
